import type { Questionnaire } from '@/typings/Questionnaire';
import evaluateExpression from '@helpers/evaluateExpression';

const isObject = (thing: unknown): thing is Record<string, unknown> => typeof thing === 'object' && thing !== null;

const isSubFieldVisible = (
  subField: Pick<Questionnaire.Field, 'conditionExpression'>,
  itemValues: unknown,
): boolean => {
  if (
    subField.conditionExpression
    && subField.conditionExpression.expression
    && isObject(itemValues)
  ) {
    const variablesWithValues = subField.conditionExpression.variables?.map(variable => ({
      ...variable,
      value: itemValues[variable.referenceId],
    })) || [];

    const result = evaluateExpression({
      expression: subField.conditionExpression.expression,
      id: 'isSubFieldVisible',
      variables: variablesWithValues.reduce((acc, val) => ({
        ...acc,
        [val.variableName]: val.value,
      }), {}),
    });

    return Boolean(result);
  }
  return true;
};

export default isSubFieldVisible;